import React from 'react'

const ErrorModalUI = ({
  title,
  errorList,
  onCloseClick,
  type = 'error' // Can be 'error', 'warning', or 'info'
}) => {
  // Determine styling based on type
  const getTypeStyles = () => {
    switch (type) {
      case 'warning':
        return {
          titleColor: '#856404',
          containerBg: '#fff3cd',
          containerBorder: '#ffeaa7',
          textColor: '#856404',
          iconColor: '#ffc107'
        }
      case 'info':
        return {
          titleColor: '#004085',
          containerBg: '#d1ecf1',
          containerBorder: '#bee5eb',
          textColor: '#004085',
          iconColor: '#17a2b8'
        }
      default: // error
        return {
          titleColor: '#dc3545',
          containerBg: '#f8d7da',
          containerBorder: '#f5c6cb',
          textColor: '#721c24',
          iconColor: '#dc3545'
        }
    }
  }

  const typeStyles = getTypeStyles()

  const getIcon = () => {
    switch (type) {
      case 'warning':
        return '⚠️'
      case 'info':
        return 'ℹ️'
      default:
        return '⚠'
    }
  }

  return (
    <div className="modal-backdrop" style={backdropStyle}>
      <div className="modal-content" style={modalStyle}>
        <h3 style={{ marginTop: 0, color: typeStyles.titleColor }}>
          {title || (type === 'warning' ? 'Warning' : type === 'info' ? 'Information' : 'Error')}
        </h3>

        {errorList && errorList.length > 0 && (
          <div style={{
            ...errorContainerStyle,
            backgroundColor: typeStyles.containerBg,
            borderColor: typeStyles.containerBorder
          }}>
            {errorList.map((error, idx) => (
              <div key={idx} style={errorItemStyle}>
                <span style={{
                  ...errorIconStyle,
                  color: typeStyles.iconColor
                }}>
                  {getIcon()}
                </span>
                <span style={{
                  ...errorTextStyle,
                  color: typeStyles.textColor
                }}>
                  {typeof error === 'string' ? error : error.message || 'An error occurred'}
                </span>
              </div>
            ))}
          </div>
        )}

        <div style={{ marginTop: '20px', textAlign: 'right' }}>
          <button
            onClick={onCloseClick}
            style={closeButtonStyle}
            onMouseOver={(e) => e.target.style.backgroundColor = '#5a6268'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#6c757d'}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  )
}

const backdropStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000
}

const modalStyle = {
  backgroundColor: 'white',
  borderRadius: '8px',
  padding: '24px',
  minWidth: '400px',
  maxWidth: '600px',
  maxHeight: '80vh',
  overflowY: 'auto',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
}

const errorContainerStyle = {
  border: '1px solid',
  borderRadius: '6px',
  padding: '15px',
  marginTop: '15px'
}

const errorItemStyle = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '10px',
  marginBottom: '10px'
}

const errorIconStyle = {
  fontSize: '20px',
  flexShrink: 0,
  marginTop: '2px'
}

const errorTextStyle = {
  fontSize: '14px',
  lineHeight: '1.5',
  flex: 1
}

const closeButtonStyle = {
  padding: '10px 24px',
  fontSize: '14px',
  fontWeight: '500',
  cursor: 'pointer',
  border: 'none',
  borderRadius: '4px',
  backgroundColor: '#6c757d',
  color: '#fff',
  transition: 'all 0.2s'
}

export default ErrorModalUI